import {
  Swiper, Navigation, EffectFade,
} from 'swiper';

const verticalTabs = '.js__vertical-tabs';
const swiperContainerClass = '.js_vertical-tabs__swiper';
let lastTop = 0;

function updateTop(section) {
  const child = section.querySelector('.js__vertical-tabs__nav');
  const parent = child.parentElement;
  const childRect = child.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const distanceTop = childRect.top - parentRect.top;

  if (lastTop !== distanceTop) {
    const cardsInner = section.querySelectorAll('.js__vertical-tabs__card-inner');

    cardsInner.forEach((block) => {
      // eslint-disable-next-line no-param-reassign
      block.style.top = `${distanceTop}px`;
    });
    lastTop = distanceTop;
  }
}

function initSwipers() {
  const sections = document.querySelectorAll(verticalTabs);

  sections.forEach((section) => {
    const slider = section.querySelector(swiperContainerClass);
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      modules: [Navigation, EffectFade],
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChangeTransitionStart: (curSwiper) => {
          const oldActive = section.querySelector('.active');
          const newActive = section.querySelectorAll('.vertical-tabs__nav-link')[curSwiper.realIndex];
          oldActive.classList.remove('active');
          newActive.classList.add('active');
        },
      },
    });

    const links = section.querySelectorAll('.vertical-tabs__nav-link');

    links.forEach((link, index) => {
      link.addEventListener('mouseenter', () => {
        swiper.slideTo(index + 1);
      });
    });

    setTimeout(() => {
      updateTop(section);
    }, 0);
  });
}

window.addEventListener('resize', () => {
  const sections = document.querySelectorAll(verticalTabs);
  sections.forEach((section) => {
    updateTop(section);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initSwipers();
    });
  } else {
    initSwipers();
  }
});
